module.exports = __webpack_public_path__ + "static/img/loginbg.44ac51ad.svg";